import { useState, FormEvent } from 'react';

const serviceOptions = [
  'Air Conditioning Repair',
  'Air Conditioning Installation',
  'Heating System Repair',
  'Heating System Installation',
  'HVAC Maintenance',
  'Indoor Air Quality',
  'Commercial HVAC',
  'Emergency Service',
  'Other',
];

export default function FinalCTA() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msgLen, setMsgLen] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const msg = (form.elements.namedItem('message') as HTMLTextAreaElement)?.value || '';
    if (msg.length > 500) return;
    setLoading(true);
    const data = new URLSearchParams();
    ['name', 'phone', 'email', 'service', 'message'].forEach((f) => {
      const el = form.elements.namedItem(f) as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (el) data.append(f, el.value);
    });
    try {
      await fetch('https://readdy.ai/api/form/d7ap8rv6e3lk9704a210', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
    } catch { /* silent */ }
    setSubmitted(true);
    setLoading(false);
  };

  return (
    <section id="contact" className="bg-[#0a1628] py-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left */}
          <div className="lg:w-[44%]">
            <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">Get Started</span>
            <h2
              className="text-4xl md:text-5xl font-bold text-white mt-3 mb-5 leading-tight"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Get Reliable HVAC
              <br />
              Service Today
            </h2>
            <p className="text-[#9ca3af] text-base leading-relaxed mb-8">
              Whether you need repair, replacement, or a full system upgrade — Air-Tek NC delivers reliable HVAC solutions designed to perform. We offer 100% financing so you can get serviced immediately.
            </p>

            {/* Phone */}
            <a href="tel:9193489399" className="flex items-center gap-4 mb-6 group cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/30 group-hover:bg-[#00d4ff]/20 transition-colors duration-200 shrink-0">
                <i className="ri-phone-line text-[#00d4ff] text-2xl" />
              </div>
              <div>
                <p className="text-[#6b7280] text-xs uppercase tracking-wider">Call Now — Available 24/7</p>
                <p className="text-[#00d4ff] text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>(919) 348-9399</p>
              </div>
            </a>

            {/* Email */}
            <a href="mailto:airteknc@gmail.com" className="flex items-center gap-4 mb-6 group cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/30 group-hover:bg-[#00d4ff]/20 transition-colors duration-200 shrink-0">
                <i className="ri-mail-line text-[#00d4ff] text-2xl" />
              </div>
              <div>
                <p className="text-[#6b7280] text-xs uppercase tracking-wider">Email Us</p>
                <p className="text-white text-base font-medium">airteknc@gmail.com</p>
              </div>
            </a>

            {/* Address */}
            <div className="flex items-start gap-4 mb-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/30 shrink-0">
                <i className="ri-map-pin-2-line text-[#00d4ff] text-2xl" />
              </div>
              <div>
                <p className="text-[#6b7280] text-xs uppercase tracking-wider">Address</p>
                <p className="text-white text-base font-medium">653 Connors Cove</p>
                <p className="text-[#9ca3af] text-sm">Hope Mills, NC 28348</p>
              </div>
            </div>

            <div className="space-y-3">
              {[
                'Fast response times — available 24/7',
                'Licensed & insured technicians',
                '100% financing available',
                'Transparent pricing, no hidden fees',
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-[#00d4ff]" />
                  </div>
                  <span className="text-[#9ca3af] text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Form */}
          <div className="lg:w-[56%] w-full">
            <div className="bg-[#1a2535] border border-white/8 rounded-2xl p-8">
              {submitted ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/30 mx-auto mb-4">
                    <i className="ri-check-double-line text-[#00d4ff] text-3xl" />
                  </div>
                  <h3 className="text-white font-bold text-2xl mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Request Received!
                  </h3>
                  <p className="text-[#9ca3af] text-base">
                    We&apos;ll be in touch shortly. For urgent needs, call us at{' '}
                    <a href="tel:9193489399" className="text-[#00d4ff] font-medium">(919) 348-9399</a>.
                  </p>
                </div>
              ) : (
                <>
                  <h3 className="text-white font-bold text-xl mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Request Service Online
                  </h3>
                  <p className="text-[#6b7280] text-sm mb-6">
                    Or call us directly at{' '}
                    <a href="tel:9193489399" className="text-[#00d4ff] font-medium">(919) 348-9399</a>
                  </p>
                  <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="text-[#9ca3af] text-xs font-medium mb-1.5 block">Full Name *</label>
                        <input
                          name="name"
                          type="text"
                          required
                          placeholder="John Smith"
                          className="w-full bg-[#0f1923] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-[#4b5563] focus:outline-none focus:border-[#00d4ff]/50 transition-colors duration-200"
                        />
                      </div>
                      <div>
                        <label className="text-[#9ca3af] text-xs font-medium mb-1.5 block">Phone Number *</label>
                        <input
                          name="phone"
                          type="tel"
                          required
                          placeholder="(919) 000-0000"
                          className="w-full bg-[#0f1923] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-[#4b5563] focus:outline-none focus:border-[#00d4ff]/50 transition-colors duration-200"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-[#9ca3af] text-xs font-medium mb-1.5 block">Email Address</label>
                      <input
                        name="email"
                        type="email"
                        placeholder="john@example.com"
                        className="w-full bg-[#0f1923] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-[#4b5563] focus:outline-none focus:border-[#00d4ff]/50 transition-colors duration-200"
                      />
                    </div>
                    <div>
                      <label className="text-[#9ca3af] text-xs font-medium mb-1.5 block">Service Needed *</label>
                      <select
                        name="service"
                        required
                        className="w-full bg-[#0f1923] border border-white/10 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-[#00d4ff]/50 transition-colors duration-200 cursor-pointer"
                      >
                        <option value="">Select a service...</option>
                        {serviceOptions.map((o) => (
                          <option key={o} value={o}>{o}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="text-[#9ca3af] text-xs font-medium mb-1.5 block">
                        Message <span className="text-[#4b5563]">({msgLen}/500)</span>
                      </label>
                      <textarea
                        name="message"
                        rows={4}
                        maxLength={500}
                        placeholder="Describe your HVAC issue or project..."
                        onChange={(e) => setMsgLen(e.target.value.length)}
                        className="w-full bg-[#0f1923] border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-[#4b5563] focus:outline-none focus:border-[#00d4ff]/50 transition-colors duration-200 resize-none"
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full bg-[#00d4ff] hover:bg-[#00b8d9] disabled:opacity-60 text-[#0a1628] font-bold text-base py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {loading ? 'Sending...' : 'Request Service'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
